export enum HttpStatus {
  InternalError = 500,
  Error = 400,
  NotAuthorized = 401,
  PageNotFound = 404,
  ForbiddenAccess = 403,
}
